// Loading this anchor module runs the full Module Federation sequence (container init,
// shared-singleton negotiation, module resolution), so a resolved import genuinely means
// USx is operational. Do NOT replace this with an HTTP probe of remoteEntry.js — that only
// proves the file is reachable, not that the remote Federated Search actually initializes.
// The specifier must stay a literal so the Module Federation plugin can analyze it statically.
// Kept in its own module so tests can mockthis call directly — the bare `federated-search/*`
// specifier itself is unmockable under Vitest.
export const loadFederatedSearchAnchor = () => import('federated-search/FederatedSearchProvider');
